export const emailTemplateUser = (body, code, courses) => {
    const email = `
  <style>
  @media only screen and (min-width: 820px) {
      .u-row {
          width: 800px !important;
      }
      .u-row .u-col {
          vertical-align: top;
      }
      .u-row .u-col-33p33 {
          width: 266.64px !important;
      }
      .u-row .u-col-100 {
          width: 800px !important;
      }
  }
  @media (max-width: 820px) {
      .u-row-container {
          max-width: 100% !important;
          padding-left: 0px !important;
          padding-right: 0px !important;
      }
      .u-row .u-col {
          min-width: 320px !important;
          max-width: 100% !important;
          display: block !important;
      }
      .u-row {
          width: calc(100% - 40px) !important;
      }
      .u-col {
          width: 100% !important;
      }
      .u-col > div {
          margin: 0 auto;
      }
  }
</style>
<center>
  <body
      class="u-col"
      style="
          width: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 100%;
          margin: 0 auto;
          font-family: arial, helvetica, sans-serif;
      "
  >
      <div
          class="u-col"
          style="
              width: 100%;
              height: 100%;
              margin: 0 auto;
              font-family: arial, helvetica, sans-serif;
          "
      >
          <h1 style="color: #b31d15">
              ¡Nuevo registro de usuario, desde CORPORATE, código = ${
                  code || body?.code
              }!
          </h1>
          <div
              class="u-col"
              style="
                  width: 450px;
                  border: solid 1px #e1e1e1;
                  border-radius: 10px;
                  overflow: hidden;
              "
          >
              <header
                  style="
                      padding: 1rem;
                      color: #fff;
                      text-align: center;
                      font-size: 1.2rem;
                      background-color: #b31d15;
                  "
              >
              ${body?.name} ${body?.lastName}
              </header>
              <div
                  class="u-row u-col u-row-container"
                  style="
                      gap: 1rem;
                      text-align: start;
                      padding: 1rem;
                      width: calc(100% - 1rem);
                      background-color: #fff;
                  "
              >
                  <h3 style="color: #222; font-size: 1rem">
                      Email:
                      <span
                          style="
                              color: #696969;
                              font-size: 1rem;
                              font-weight: 400;
                          "
                          >${body?.email}</span
                      >
                  </h3>
              </div>
              <div
                  class="u-row u-col u-row-container"
                  style="
                      gap: 1rem;
                      text-align: start;
                      padding: 1rem;
                      background-color: #fce9e8;
                      width: calc(100% - 1rem);
                  "
              >
                  <h3 style="color: #222; font-size: 1rem">
                      Empresa:
                      <span
                          style="
                              color: #696969;
                              font-size: 1rem;
                              font-weight: 400;
                          "
                          >${body?.company?.empresa_nombre || "N/A"}</span
                      >
                  </h3>
              </div>
              <div
                  class="u-row u-col u-row-container"
                  style="
                      gap: 1rem;
                      text-align: start;
                      padding: 1rem;
                      width: calc(100% - 1rem);
                      background-color: #fff;
                  "
              >
                  <h3 style="color: #222; font-size: 1rem">
                      Password:
                      <span
                          style="
                              color: #696969;
                              font-size: 1rem;
                              font-weight: 400;
                          "
                          >${body?.password}</span
                      >
                  </h3>
              </div>
              <div
                  class="u-row u-col u-row-container"
                  style="
                      gap: 1rem;
                      text-align: start;
                      padding: 1rem;
                      background-color: #fce9e8;
                      width: calc(100% - 1rem);
                  "
              >
                  <h3 style="color: #222; font-size: 1rem">
                      País:
                      <span
                          style="
                              color: #696969;
                              font-size: 1rem;
                              font-weight: 400;
                          "
                          >${body?.country.name || "N/A"}</span
                      >
                  </h3>
              </div>
              <div
                  class="u-row u-col u-row-container"
                  style="
                      gap: 1rem;
                      text-align: start;
                      padding: 1rem;
                      width: calc(100% - 1rem);
                      background-color: #fff;
                  "
              >
                  <h3 style="color: #222; font-size: 1rem">
                      Cursos:
                      <span
                          style="
                              color: #696969;
                              font-size: 1rem;
                              font-weight: 400;
                          "
                          >${courses.map((c) => c.id)}</span
                      >
                  </h3>
              </div>
              <div
                  class="u-row u-col u-row-container"
                  style="
                      gap: 1rem;
                      text-align: start;
                      padding: 1rem;
                      background-color: #fce9e8;
                      width: calc(100% - 1rem);
                  "
              >
                  <h3 style="color: #222; font-size: 1rem">
                      Código:
                      <span
                          style="
                              color: #696969;
                              font-size: 1rem;
                              font-weight: 400;
                          "
                          >${code || body?.code}</span
                      >
                  </h3>
              </div>
          </div>
      </div>
  </body>
</center>
`;

    return email;
};

export const emailTemplateByUser = () => {
    const email = `
    <style type="text/css">
    @media only screen and (min-width: 820px) {
      .u-row {
        width: 800px !important;
      }
      .u-row .u-col {
        vertical-align: top;
      }
      .u-row .u-col-33p33 {
        width: 266.64px !important;
      }
      .u-row .u-col-100 {
        width: 800px !important;
      }
    }
    @media (max-width: 820px) {
      .u-row-container {
        max-width: 100% !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
      }
      .u-row .u-col {
        min-width: 320px !important;
        max-width: 100% !important;
        display: block !important;
      }
      .u-row {
        width: calc(100% - 40px) !important;
      }
      .u-col {
        width: 100% !important;
      }
      .u-col > div {
        margin: 0 auto;
      }
    }
    body {
      margin: 0;
      padding: 0;
    }
    table,
    tr,
    td {
      vertical-align: top;
      border-collapse: collapse;
    }
    p {
      margin: 0;
    }
    .ie-container table,
    .mso-container table {
      table-layout: fixed;
    }
    * {
      line-height: inherit;
    }
    a[x-apple-data-detectors='true'] {
      color: inherit !important;
      text-decoration: none !important;
    }
    table,
    td {
      color: #000000;
    }
    #u_body a {
      color: #0000ee;
      text-decoration: underline;
    }
    </style>
    <link
    href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap"
    rel="stylesheet"
    type="text/css"
    />
    </head>
    <body
    class="clean-body u_body"
    style="
    margin: 0;
    padding: 0;
    -webkit-text-size-adjust: 100%;
    background-color: #111111;
    color: #000000;
    "
    >
    <table
    id="u_body"
    style="
      border-collapse: collapse;
      table-layout: fixed;
      border-spacing: 0;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
      vertical-align: top;
      min-width: 320px;
      margin: 0 auto;
      background-color: #111111;
      width: 100%;
    "
    cellpadding="0"
    cellspacing="0"
    >
    <tbody>
      <tr style="vertical-align: top">
        <td
          style="
            word-break: break-word;
            border-collapse: collapse !important;
            vertical-align: top;
          "
        >
          <div
            class="u-row-container"
            style="padding: 0px; background-color: transparent"
          >
            <div
              class="u-row"
              style="
                margin: 0 auto;
                min-width: 320px;
                max-width: 800px;
                overflow-wrap: break-word;
                word-wrap: break-word;
                word-break: break-word;
                background-color: transparent;
              "
            >
              <div
                style="
                  border-collapse: collapse;
                  display: table;
                  width: 100%;
                  height: 100%;
                  background-color: transparent;
                "
              >
                <div
                  class="u-col u-col-100"
                  style="
                    max-width: 320px;
                    min-width: 800px;
                    display: table-cell;
                    vertical-align: top;
                  "
                >
                  <div
                    style="
                      height: 100%;
                      width: 100% !important;
                      border-radius: 0px;
                      -webkit-border-radius: 0px;
                      -moz-border-radius: 0px;
                    "
                  >
                    <div
                      style="
                        height: 100%;
                        padding: 0px;
                        border-top: 0px solid transparent;
                        border-left: 0px solid transparent;
                        border-right: 0px solid transparent;
                        border-bottom: 0px solid transparent;
                        border-radius: 0px;
                        -webkit-border-radius: 0px;
                        -moz-border-radius: 0px;
                      "
                    >
                      <table
                        style="font-family: arial, helvetica, sans-serif"
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        border="0"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="
                                overflow-wrap: break-word;
                                word-break: break-word;
                                padding: 48px 10px 24px;
                                font-family: arial, helvetica, sans-serif;
                              "
                              align="left"
                            >
                              <table
                                width="100%"
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                              >
                                <tr>
                                  <td
                                    style="
                                      padding-right: 0px;
                                      padding-left: 0px;
                                    "
                                    align="center"
                                  >
                                    <img
                                      align="center"
                                      border="0"
                                      src="data:image/png;base64,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"
                                      alt=""
                                      title=""
                                      style="
                                        outline: none;
                                        text-decoration: none;
                                        -ms-interpolation-mode: bicubic;
                                        clear: both;
                                        display: inline-block !important;
                                        border: none;
                                        height: auto;
                                        float: none;
                                        width: 100%;
                                        max-width: 275px;
                                      "
                                      width="275"
                                    />
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="u-row-container"
            style="padding: 0px; background-color: transparent"
          >
            <div
              class="u-row"
              style="
                margin: 0 auto;
                min-width: 320px;
                max-width: 800px;
                overflow-wrap: break-word;
                word-wrap: break-word;
                word-break: break-word;
                background-color: transparent;
              "
            >
              <div
                style="
                  border-collapse: collapse;
                  display: table;
                  width: 100%;
                  height: 100%;
                  background-color: transparent;
                "
              >
                <div
                  class="u-col u-col-100"
                  style="
                    max-width: 320px;
                    min-width: 800px;
                    display: table-cell;
                    vertical-align: top;
                  "
                >
                  <div style="height: 100%; width: 100% !important">
                    <div
                      style="
                        height: 100%;
                        padding: 0px;
                        border-top: 0px solid transparent;
                        border-left: 0px solid transparent;
                        border-right: 0px solid transparent;
                        border-bottom: 0px solid transparent;
                      "
                    >
                      <table
                        style="font-family: arial, helvetica, sans-serif"
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        border="0"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="
                                overflow-wrap: break-word;
                                word-break: break-word;
                                padding: 10px;
                                font-family: arial, helvetica, sans-serif;
                              "
                              align="left"
                            >
                              <h2
                                style="
                                  margin: 0px;
                                  color: #ffffff;
                                  line-height: 140%;
                                  text-align: center;
                                  word-wrap: break-word;
                                  font-weight: normal;
                                  font-family: 'Lato', sans-serif;
                                  font-size: 18px;
                                "
                              >
                                <div>
                                  <div>
                                    <div>
                                      <strong
                                        >APRENDE • COMPARTE • IMPACTA</strong
                                      >
                                    </div>
                                  </div>
                                </div>
                              </h2>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table
                        style="font-family: arial, helvetica, sans-serif"
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        border="0"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="
                                overflow-wrap: break-word;
                                word-break: break-word;
                                padding: 10px;
                                font-family: arial, helvetica, sans-serif;
                              "
                              align="left"
                            >
                              <div
                                style="
                                  color: #ffffff;
                                  line-height: 140%;
                                  text-align: left;
                                  word-wrap: break-word;
                                "
                              >
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-align: center;
                                  "
                                >
                                  <span
                                    style="
                                      font-family: Lato, sans-serif;
                                      font-size: 18px;
                                      line-height: 25.2px;
                                    "
                                    >ADEN te acompaña a expandir el
                                    conocimiento de tus colaboradores e
                                    impactar de forma positiva en la
                                    organización.</span
                                  >
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <center
            class="u-row-container"
            style="padding: 17px 0px 0px 0px; background-color: transparent"
          >
           <img
              style="object-fit: contain;"
              height="300px"
              width="500px"
              src="https://inscripcion.aden.org/assets/images/varios/notebook.svg"
            />
                
          </center>
          <center style="font-family: arial, helvetica, sans-serif; margin: 0 auto; width: 500px; padding: 0 10px;">
            <h2 style="font-family: arial, helvetica, sans-serif; color: white;">¿Qué encontrarás
              en nuestra plataforma?
            </h2>
            <div style="width: 300px; margin: 0 auto;">          
              <p style="color: white; text-align: start;">
                <span style="color: red; font-size: 20px;">+</span> Cursos de Impacto cortos y gratuitos
              </p>
              <p style="color: white; text-align: start;">
                <span style="color: red; font-size: 20px">+</span> 100% remoto
              </p>
              <p style="color: white; text-align: start;">
                <span style="color: red; font-size: 20px">+</span> Autogestivos
              </p>
              <p style="color: white; text-align: start;">
                <span style="color: red; font-size: 20px">+</span> Certificación AcrópolisLAB
              </p>
              <p style="color: white; text-align: start;">
                <span style="color: red; font-size: 20px">+</span> Retroalimentación de experto
              </p>
            </div>
          </center>  
        </div>
          </div>
          <div
            class="u-row-container"
            style="padding: 19px 0px 0px; background-color: transparent"
          >
            <div
              class="u-row"
              style="
                margin: 0 auto;
                min-width: 320px;
                max-width: 800px;
                overflow-wrap: break-word;
                word-wrap: break-word;
                word-break: break-word;
                background-color: transparent;
              "
            >
              <div
                style="
                  border-collapse: collapse;
                  display: table;
                  width: 100%;
                  height: 100%;
                  background-color: transparent;
                "
              >
                <div
                  class="u-col u-col-100"
                  style="
                    max-width: 320px;
                    min-width: 800px;
                    display: table-cell;
                    vertical-align: top;
                  "
                >
                  <div
                    style="
                      height: 100%;
                      width: 100% !important;
                      border-radius: 0px;
                      -webkit-border-radius: 0px;
                      -moz-border-radius: 0px;
                    "
                  >
                    <div
                      style="
                        height: 100%;
                        padding: 0px;
                        border-top: 0px solid transparent;
                        border-left: 0px solid transparent;
                        border-right: 0px solid transparent;
                        border-bottom: 0px solid transparent;
                        border-radius: 0px;
                        -webkit-border-radius: 0px;
                        -moz-border-radius: 0px;
                      "
                    >
                      <table
                        style="font-family: arial, helvetica, sans-serif"
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        border="0"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="
                                overflow-wrap: break-word;
                                word-break: break-word;
                                padding: 24px 10px 48px;
                                font-family: arial, helvetica, sans-serif;
                              "
                              align="left"
                            >
                              <div
                                style="
                                  color: #ffffff;
                                  line-height: 140%;
                                  text-align: left;
                                  word-wrap: break-word;
                                "
                              >
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-align: center;
                                  "
                                >
                                  <span
                                    style="
                                      font-size: 16px;
                                      line-height: 22.4px;
                                    "
                                    ><strong
                                      ><span
                                        style="
                                          font-family: Lato, sans-serif;
                                          line-height: 22.4px;
                                          font-size: 16px;
                                        "
                                        >ADEN entregará una certificación de
                                        Acrópolis LAB por cada curso completado.
                                      </span></strong
                                    ></span
                                  >
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-align: center;
                                  "
                                >
                                  <br /><span
                                    style="
                                      font-family: Lato, sans-serif;
                                      font-size: 16px;
                                      line-height: 22.4px;
                                    "
                                    >Ingresa a la plataforma educativa de ADEN AcrópolisLAB
                                  </span>
                                </p>
                                <div style="text-align: center; margin-top: 18px;">
                                    <a style="text-align: center; cursor: pointer;" target="_blank" href="https://app.acropolislab.com/"
                                        ><button
                                          style="
                                            cursor: pointer;
                                            background-color: #b31d15;
                                            padding: 12px 18px;
                                            border-radius: 5px;
                                            margin-top: 8px;
                                            color: #ffffff;
                                            outline: none;
                                            border: none;
                                            cursor: pointer;
                                            font-weight: bold;
                                          "
                                        >
                                          INGRESA A LA PLATAFORMA
                                        </button></a
                                      >
                                </div>
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-align: center;
                                  "
                                >
                                  <br /><strong
                                    ><span
                                      style="
                                        font-family: Lato, sans-serif;
                                        font-size: 20px;
                                        line-height: 28px;
                                      "
                                      >¡Es hora de empezar!</span
                                    ></strong
                                  >
                                </p>
                                <p
                                  style="font-size: 14px; line-height: 140%"
                                ></p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="u-row-container"
            style="padding: 0px; background-color: #000000"
          >
            <div
              class="u-row"
              style="
                margin: 0 auto;
                min-width: 320px;
                max-width: 800px;
                overflow-wrap: break-word;
                word-wrap: break-word;
                word-break: break-word;
                background-color: transparent;
              "
            >
              <div
                style="
                  border-collapse: collapse;
                  display: table;
                  width: 100%;
                  height: 100%;
                  background-color: transparent;
                "
              >
                <div
                  class="u-col u-col-100"
                  style="
                    max-width: 320px;
                    min-width: 800px;
                    display: table-cell;
                    vertical-align: top;
                  "
                >
                  <div
                    style="
                      background-color: #000000;
                      height: 100%;
                      width: 100% !important;
                      border-radius: 0px;
                      -webkit-border-radius: 0px;
                      -moz-border-radius: 0px;
                    "
                  >
                    <div
                      style="
                        height: 100%;
                        padding: 0px;
                        border-top: 0px solid transparent;
                        border-left: 0px solid transparent;
                        border-right: 0px solid transparent;
                        border-bottom: 0px solid transparent;
                        border-radius: 0px;
                        -webkit-border-radius: 0px;
                        -moz-border-radius: 0px;
                      "
                    >
                      <table
                        style="font-family: arial, helvetica, sans-serif"
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        border="0"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="
                                overflow-wrap: break-word;
                                word-break: break-word;
                                padding: 24px;
                                font-family: arial, helvetica, sans-serif;
                              "
                              align="left"
                            >
                              <div
                                style="
                                  color: #ffffff;
                                  line-height: 140%;
                                  text-align: left;
                                  word-wrap: break-word;
                                "
                              >
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 140%;
                                    text-align: center;
                                  "
                                >
                                  <span
                                    style="
                                      font-family: Lato, sans-serif;
                                      font-size: 12px;
                                      line-height: 16.8px;
                                    "
                                    ><strong
                                      >Todos los derechos reservados | © ADEN
                                      2022</strong
                                    ></span
                                  >
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
    </table>
    </body>
`;

    return email;
};
